"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/no-extraneous-dependencies
const theme_tools_1 = require("@chakra-ui/theme-tools");
const parts = (0, theme_tools_1.anatomy)('tag').parts('container', 'label', 'icon', 'iconRight');
const baseStyle = ({ colorScheme }) => ({
    container: {
        alignItems: 'center',
        backgroundColor: `${colorScheme}.200`,
        borderRadius: 'radius-full',
        display: 'inline-flex',
        gap: 'space-4',
    },
    icon: {
        color: `${colorScheme}.700`,
    },
    iconRight: {
        color: `${colorScheme}.700`,
    },
    label: {
        alignItems: 'center',
        color: `${colorScheme}.700`,
        display: 'flex',
        fontWeight: 'weight-500',
    },
});
const sizes = {
    md: {
        container: {
            height: '2rem',
            paddingX: 'space-12',
        },
    },
    sm: {
        container: {
            height: '1.5rem',
            paddingX: 'space-8',
        },
    },
};
const defaultProps = {
    colorScheme: 'grey',
    size: 'md',
};
const TagTheme = {
    baseStyle,
    defaultProps,
    parts: parts.keys,
    sizes,
};
exports.default = TagTheme;
